module.exports = __webpack_public_path__ + "static/media/45.8209c245.JPG";